import { render, staticRenderFns } from "./SelecterDots.vue?vue&type=template&id=2029919a&"
import script from "./SelecterDots.vue?vue&type=script&lang=js&"
export * from "./SelecterDots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports